import AbstractWeatherModel from '@/lib/grow/abstract-weather-model'

export default class AccumulatedTemperature extends AbstractWeatherModel {
  static fromApiResponse(data, observation) {
    let at = new AccumulatedTemperature()
    at.setValuesFromApi(data, observation)
    at.baseYear = data.baseYear
    at.baseMonth = data.baseMonth
    at.baseDay = data.baseDay
    at.targetYear = data.targetYear
    at.targetMonth = data.targetMonth
    at.targetDay = data.targetDay
    at.zoneId = data.zoneId
    at.lowerLimitTemperature = data.lowerLimitTemperature
    at.temperature = data.temperature
    at.roundedTemperature = data.roundedTemperature
    return at
  }
}
